"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChartError = _ref => {
  let {
    chartId = "",
    isAlarm = false
  } = _ref;
  const chartError = (0, _reactRedux.useSelector)(_selectors.getChartErrors)[chartId] || null;
  const {
    [72]: tError = "" // Internal server error when loading line charts
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("center", null, chartError ? /*#__PURE__*/_react.default.createElement("div", {
    className: "container-box-shadow",
    style: {
      padding: "24px",
      background: "#FCFCFD",
      borderRadius: isAlarm ? "0" : "10px 0 10px 10px"
    }
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      fontSize: 20,
      fontWeight: "bold",
      margin: 0,
      color: "var(--main-color-cl-01)"
    }
  }, tError)) : /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    sx: {
      color: "var(--main-color-cl-01)"
    }
  })), [isAlarm, chartError, tError]);
};
var _default = exports.default = ChartError;